import { AgreementStoreState } from "@/shared/interfaces/transaction/Agreement.interface";
import { Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";

const state: AgreementStoreState = {
    termsAndConditions: false,
    immediatePublication: false,
};

const mutations: MutationTree<AgreementStoreState> = {
    termsAndConditions: function(state, agreement: boolean) {
        state.termsAndConditions = agreement;
    },
    immediatePublication: function(state, agreement: boolean) {
        state.immediatePublication = agreement;
    },
};

const agreement: Module<AgreementStoreState, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
};

export default agreement;
